import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getAndroidDocs } from 'api';

// Then, handle actions in your reducers:
const androidDocsSlice = createSlice({
  name: 'androidDocs',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    androidDocsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    androidDocsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    androidDocsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    androidDocsResetState: (state) => {
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  androidDocsFetchStart,
  androidDocsFetchSuccess,
  androidDocsFetchFail,
  androidDocsResetState,
} = androidDocsSlice.actions;

// The reducer
export const androidDocsReducer = androidDocsSlice.reducer;

// Asynchronous thunk action
export const androidDocsFetch = (data: Object) => (dispatch) => {
  dispatch(androidDocsFetchStart());

  getAndroidDocs(data)
    .then((androidDocs) => {
      dispatch(androidDocsFetchSuccess(androidDocs.data));
    })
    .catch((error) => {
      dispatch(androidDocsFetchFail(error));
    });
};
